import axios from "axios";
import { centralizedHost } from "~/Utils";
import { decodeHTML } from "~/Utils/CommonUtils";
import { ModuleFields } from "~/Utils/drilldownData";

// Define the option type for select fields
export interface OptionType {
  label: string;
  value: string;
}

// Create a type for fields that may have async options
export type AsyncSelectField = ModuleFields & {
  loadOptions?: () => Promise<OptionType[]>;
};

export const fetchDineCategoryDropdown = async () => {
  try {
    const parentUrl = `${centralizedHost}/api/shop-category-parent`;
    const childUrl = `${centralizedHost}/api/shop-category-child`;

    // Call both APIs in parallel
    const [parentRes, childRes] = await Promise.all([axios.get(parentUrl), axios.get(childUrl)]);

    // Extract parent list
    const parentData = parentRes?.data || [];
    const parentOptions = parentData
      .filter((item: any) => item.published === true)
      .map((item: { id: string; name: string }) => ({
        value: item.id,
        label: decodeHTML(item.name),
      }));

    // Extract + filter child list
    const childData = childRes?.data || [];
    const filteredChild = childData.filter(
      (item: any) => item.published === true && item.type?.toLowerCase() === "dine"
    );

    const childOptions = filteredChild.map((item: { id: string; name: string }) => ({
      value: item.id,
      label: decodeHTML(item.name),
    }));

    // Return both values
    return [...parentOptions, ...childOptions];
  } catch (error) {
    console.error("Failed to fetch dropdowns:", error);
    return [];
  }
};
